import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import React from 'react'
import { WizTableForm } from '../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
import moment from "moment";
//配置项
let componentName = 'requirementPersonnel'


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "经销商名称",
    name: "dealerName",
    tableItem: {
      width: 150
    },
    searchItem: {
    }
  },
  {
    title: "经销商简称",
    name: "shortName",
    tableItem: {
      width: 100
    },
  },
  {
    title: "品牌",
    name: "brandId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },
  {
    title: '销售代码',
    name: 'preSalesNumber',
    searchItem: {},
    tableItem: {width: 100}
  },
  {
    title: '售后代码',
    name: 'afterSalesNumber',
    searchItem: {},
    tableItem: {width: 100}
  },
  {
    title: '预估开业时间',
    name: 'openTime',
    tableItem:{
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: '开店时间',
    name: 'dealerOpenTime',
    tableItem:{
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },

  {
    title: "是否需要标杆店实践",
    name: "benchmark",
    dataIndex: "benchmark",
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" },
    ],
    tableItem: {
      width: 150
    },
  },
  {
    title: "品牌",
    name: "brandName",
    tableItem: {
      width: 80
    },
  },
  {
    title: '站点类型',
    name: 'type',
    dict: [
      {code: 1, codeName: '经销商'},
      {code: 2, codeName: '服务商'},
      { code: 99, codeName: '暂定' },
      { code: 0, codeName: '无' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 80
    }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {width: 180},
    dict: [
      { code: 0, codeName: "培训中" },
    //  { code: 1, codeName: "已完成" },
      { code: 2, codeName: "达标确认" },
      { code: 3, codeName: "人员有变更，请重新确认" },
      { code: 4, codeName: "已开店达标确认" },
      { code: 5, codeName: "已开店未达标" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "完成时间",
    name: "completeTime",
    tableItem: {
      render: (text, record) => {
        return formatterMinute(text)
      }
    },
  },
  {
    title: "标杆店实践",
    name: "benchmark",
    dataIndex: "benchmark",
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" },
    ],
    searchItem: {type: 'select'},
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        collapse: false,
        buttonSort: ['export','exportTypeReport'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
          {
            key: 'exportTypeReport',
            custom: true,
            params: {icon: 'export', children: '新开业人员培训详情导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "exportTypeReport",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
       // selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      // showAuth: {
      //   title: '适用范围',
      //   dataIndex: 'authData'
      // },
      rowOperateSort: ['look', 'requirementPersonnelApply'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/requirementPersonnel/requirementPersonnelList/requirementPersonnelDetailList"
            }
          }
        },
        {
          key: "requirementPersonnelApply",
          custom: true,
          params: { children: "测评报名管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/requirementPersonnel/requirementPersonnelList/apply"
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: false };
            if (record.record && record.record.type === 14) {
              result.disabled = true
            }
            return result
          },
        },
      ],
      commonOperate: {
        add: true,
        update: true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  export: {
    path: `${componentName}/getList`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  exportTypeReport: {
    path: `${componentName}/exportTypeReport`,
    payload: {
      key: `${componentName}@exportTypeReport`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
